<template>
  <VisionLink
    :class="$b(
      {
        productImage: !!navItem.productSku
      }
    )"
    display="block"
    :to="resolveLocalePath(slugToPagePath(navItem.internalLink.slug))"
  >
    <div :class="$b('content')">
      <div
        v-if="navItem.image?.responsiveImage || navItem.productSku"
        :class="$b('image')"
      >
        <DynamicImg
          v-if="navItem.productSku"
          :sku="navItem.productSku"
          :width="400"
          :height="400"
          bg="transparent"
          :class="$b('product-image')"
        />
        <DatoCmsImage
          v-else
          :class="$b('image-inner')"
          :data="navItem.image.responsiveImage"
          layout="fill"
          object-fit="cover"
          :object-position="`${navItem.image.focalPoint.x * 100}% ${
            navItem.image.focalPoint.y * 100
          }%`"
          sizes="(max-width: 600px) 200px, 250px"
        />
      </div>
      <span :class="$b('image-text')">
        {{ navItem.linkText }}
      </span>
    </div>
  </VisionLink>
</template>
<script setup lang="ts">
import type { ResponsiveImageType } from 'vue-datocms'
import { Image as DatoCmsImage } from 'vue-datocms'

const { resolveLocalePath, slugToPagePath } = useUrlBuilder()

defineOptions({
  name: 'MainNavImageCard'
})

interface Props {
  navItem: {
    image: {
      responsiveImage: ResponsiveImageType
    }
    linkText: string
    internalLink: {
      slug: string
    }
    interLinkQueryParams: string
    productSku: string
  }
}

defineProps<Props>()

</script>
<style lang="postcss">
.MainNavImageCard {
  @apply w-full;

  &:hover {
    .MainNavImageCard__image-text::before {
      @apply scale-x-100 origin-left;
    }
    .MainNavImageCard__image .MainNavImageCard__product-image,
    .MainNavImageCard__image .MainNavImageCard__image-inner {
      @apply scale-[1.03];
    }
  }
}

.MainNavImageCard__image {
  @apply aspect-[167/217] w-full relative rounded-md overflow-hidden;

  > div {
    @apply transition-transform duration-300;
  }
}

.MainNavImageCard--product-image {
  .MainNavImageCard__image {
    @apply bg-grey-300 aspect-[216/249] overflow-visible;
  }
}

.MainNavImageCard__product-image {
  @apply absolute w-[calc(100%_+_3.5rem)] left-1/2 top-1/2
  -translate-x-1/2 -translate-y-1/2
  lg:w-[cal(100%_+_8rem)];
}

.MainNavImageCard__content {
  @apply block w-full;
}

.MainNavImageCard__image-text {
  @apply block mt-3 relative w-fit;

  @screen lgMax {
    @apply text-sm leading-snug;
  }

  &::before {
    @apply content-[''] absolute w-full h-[1px] -bottom-0.5 left-0
    bg-black
    scale-x-0 origin-right transition-transform duration-500;
  }
}
</style>